/* ================================
   GOOGLE SHEET CONFIG
================================ */
const SHEET_ID = "1DKx3paHjjjWOonK0O98Uv7GYQejryUJTnF2XpJUg-64";
const SHEET_NAME = "NewEra -store-locator";
const API_KEY = "AIzaSyAhY78izIR-ojgL1GLpT6Uk4Okamb-9O-4";

const API_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${encodeURIComponent(SHEET_NAME)}?key=${API_KEY}`;


/* ================================
   INIT
================================ */
document.addEventListener("DOMContentLoaded", () => {
  initStoreLocator();
});

/* ================================
   MAIN FUNCTION
================================ */
async function initStoreLocator() {
  const input = document.getElementById("storeSearch");
  const countLabel = document.getElementById("storeCount");
  const storeContainer = document.getElementById("storeCards");
  const template = document.getElementById("storeCardTemplate");
  const suggestionBox = document.getElementById("suggestionBox");

  const noResultsMessage = document.createElement("div");
  noResultsMessage.textContent = "No stores are available in this location.";
  noResultsMessage.className = "no-results-message";
  noResultsMessage.style.display = "none";
  storeContainer.appendChild(noResultsMessage);

  if (countLabel) countLabel.style.display = "none";

  const cards = [];
  const storeSuggestions = new Map();

  const normalize = str =>
    (str || "").toLowerCase().replace(/\s+/g, "");

  try {
    /* ================================
       FETCH GOOGLE SHEET DATA
    ================================ */
    const res = await fetch(API_URL);
    const data = await res.json();

    if (!data.values || !data.values.length) {
      console.error("No data found in sheet");
      return;
    }

    const headers = data.values[0];
    const records = data.values.slice(1);

    records.forEach(row => {
      const rowData = headers.reduce((obj, key, i) => {
        obj[key.trim()] = row[i] ? row[i].trim() : "";
        return obj;
      }, {});

      const {
        "Store Name": storeName,
        State: state,
        City: city,
        "Get Directions": directionsLink,
        Pincode: pincode
      } = rowData;

      if (!storeName) return;

      /* ================================
         CREATE STORE CARD
      ================================ */
      const clone = template.content.cloneNode(true);

      clone.querySelector(".store-name").textContent = storeName;
      clone.querySelector(".store-city").textContent = city;
      clone.querySelector(".store-state").textContent = state;

      // Show city + state as address
      const addressEl = clone.querySelector(".store-address");
      if (addressEl) {
        addressEl.textContent = `${city}, ${state}`;
      }

      // Directions link
      const directionsAnchor = clone.querySelector(
        ".store-directions a"
      );
      if (directionsLink) {
        directionsAnchor.href = directionsLink;
        directionsAnchor.target = "_blank";
      } else {
        directionsAnchor.href = "#";
      }

      const cardEl = clone.querySelector(".store-card");
      cardEl.dataset.city = city;
      cardEl.dataset.state = state;
      cardEl.dataset.pincode = pincode || "";

      setTimeout(() => cardEl.classList.add("loaded"), 50);

      storeContainer.appendChild(clone);
      cards.push(cardEl);

      /* ================================
         SEARCH SUGGESTIONS
      ================================ */
      const cityStateKey = normalize(`${city}${state}`);
      if (!storeSuggestions.has(cityStateKey)) {
        storeSuggestions.set(cityStateKey, {
          suggestion: `${city}, ${state}`,
          city,
          state
        });
      }

      if (pincode && !storeSuggestions.has(pincode)) {
        storeSuggestions.set(pincode, {
          suggestion: pincode,
          pincode
        });
      }
    });

    /* ================================
       FILTER CARDS
    ================================ */
    function filterCards(term) {
      const search = normalize(term);
      let found = 0;

      cards.forEach(card => {
        const combined = normalize(
          `${card.dataset.city}${card.dataset.state}${card.dataset.pincode}`
        );

        const isMatch = combined.includes(search);
        card.style.display = isMatch ? "flex" : "none";
        if (isMatch) found++;
      });

      noResultsMessage.style.display = found ? "none" : "block";
      if (countLabel) {
        countLabel.style.display = "block";
        countLabel.textContent = `${found} Store${found !== 1 ? "s" : ""} found`;
      }
    }

    function showAllCards() {
      cards.forEach(card => (card.style.display = "flex"));
      noResultsMessage.style.display = "none";
      if (countLabel) countLabel.style.display = "none";
    }

    /* ================================
       SUGGESTIONS UI
    ================================ */
    function showSuggestions(term) {
      suggestionBox.innerHTML = "";
      if (!term) return;

      const search = normalize(term);
      const matches = Array.from(storeSuggestions.values()).filter(item =>
        normalize(item.suggestion).includes(search)
      );

      matches.forEach(item => {
        const div = document.createElement("div");
        div.className = "suggestion-place";
        div.textContent = item.suggestion;

        div.addEventListener("click", () => {
          input.value = item.suggestion;
          suggestionBox.innerHTML = "";

          if (item.city && item.state) {
            filterCards(`${item.city} ${item.state}`);
          } else if (item.pincode) {
            filterCards(item.pincode);
          }
        });

        suggestionBox.appendChild(div);
      });
    }

    /* ================================
       INPUT EVENTS
    ================================ */
    let debounce;
    input.addEventListener("input", () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const term = input.value.trim();
        if (!term) {
          showAllCards();
          suggestionBox.innerHTML = "";
          return;
        }
        showSuggestions(term);
        filterCards(term);
      }, 150);
    });

    /* ================================
       KEYBOARD NAVIGATION
    ================================ */
    let selectedIndex = -1;

    input.addEventListener("keydown", e => {
      const items = suggestionBox.querySelectorAll(".suggestion-place");
      if (!items.length) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        selectedIndex = Math.max(selectedIndex - 1, 0);
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (items[selectedIndex]) items[selectedIndex].click();
      }

      items.forEach((item, i) =>
        item.classList.toggle("highlighted", i === selectedIndex)
      );
    });

    document.addEventListener("click", e => {
      if (!input.contains(e.target) && !suggestionBox.contains(e.target)) {
        suggestionBox.innerHTML = "";
      }
    });
  } catch (error) {
    console.error("Error fetching store data:", error);
  }
}
